import ViewOffer from "./ViewOffer";

export default ViewOffer